import { useEffect } from 'react'

import { getCable } from './cable'

export type TeamChatroomPayload = {
  teamChatroomId: string
  message: {
    id: string
    content: string
    createdAt: string
    senderType: 'SchoolCoach' | 'TeamCoach'
    senderName: string
  }
}

type Handler = (payload: TeamChatroomPayload) => void

export function useTeamChatroomChannel(teamChatroomId: string, handler: Handler) {
  useEffect(() => {
    if (!teamChatroomId) return

    const subscription = getCable().subscriptions.create(
      { channel: 'TeamChatroomChannel', team_chatroom_id: teamChatroomId },
      {
        received: (data: TeamChatroomPayload) => {
          if (data.teamChatroomId === teamChatroomId) {
            handler(data)
          }
        },
      },
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [teamChatroomId, handler])
}
